import { type ReactNode, useState } from 'react'

import { HeaderContext, type HeaderState } from '@/lib/provider/HeaderContext'

function HeaderProvider({ children }: { children: ReactNode }) {
  const [title, setTitle] = useState<string>('')
  const [isFullPage, setIsFullPage] = useState<boolean>(false)
  const [showQuickSelection, setShowQuickSelection] = useState<boolean>(true)

  const value: HeaderState = {
    title,
    setTitle,
    showQuickSelection,
    setShowQuickSelection,
    isFullPage,
    setIsFullPage,
  }

  return <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>
}

export default HeaderProvider